module.exports = __webpack_public_path__ + "img/img23.273e36de.svg";